'use client';

import { useSegmentStandardTrack } from '../lib/useSegmentStandardTrack';

type LinkClickedProps = {
  entityName: string;
  destinationUrl: string;
  linkCopy?: string;
  sectionName?: string;
  linkPosition?: number;
  parentEventId?: string;
  eventId?: string;
  additionalAttributes?: Record<string, unknown>;
  immediate?: boolean;
};

type LinkClickedPayload = {
  deployable_name: string | undefined;
  deployable_version: string | undefined;
  pageview_id: string | undefined;
  page_name: string | undefined;
  page_url: string | undefined;
  event_id: string;
  parent_event_id: string | undefined;
  entity_name: string;
  destination_url: string;
  link_copy: string | undefined;
  section_name: string | undefined;
  link_position: number | undefined;
  additional_attributes: Record<string, unknown>;
};

export const useLinkClicked = ({
  entityName,
  destinationUrl,
  linkCopy,
  sectionName,
  linkPosition,
  parentEventId,
  eventId,
  additionalAttributes,
  immediate,
}: LinkClickedProps) => {
  const track = useSegmentStandardTrack('Link Clicked', immediate);

  return (overrideProps?: Partial<LinkClickedPayload> | null, callback?: () => void) =>
    void track(
      {
        entity_name: entityName,
        destination_url: destinationUrl,
        link_copy: linkCopy,
        section_name: sectionName,
        link_position: linkPosition,
        ...overrideProps,
      },
      { eventId, parentEventId, additionalAttributes },
    )?.finally(() => {
      callback?.();
    });
};
